import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {useQuery} from "@apollo/client";
import noop from "lodash/noop";
import compose from "lodash/flowRight";
import {withTranslation} from "@unibuddy/intl";
import {AccessibleReactSelect} from "../../../../components/AccessibleReactSelect/AccessibleReactSelect";
import {myUniversityDegreesWithFilterQuery} from "../../queries/myUniversityDegreesWithFilterQuery";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_EMPTY_DEGREE, INTL_LOADING} from "../../../../translations/signup";

const mapDegrees = (degrees) => degrees.map(({id, name}) => ({value: id, label: name}));

const DegreeAutocomplete = ({
    degreeLevel,
    value,
    onChange,
    multiple,
    placeholder,
    universitySlug,
    name,
    onBlur,
    t,
}) => {
    const [key, setKey] = useState("default");

    const {data, loading} = useQuery(myUniversityDegreesWithFilterQuery, {
        variables: {
            nameContains: "",
            universitySlug,
            degreeLevel,
        },
        skip: !universitySlug,
        fetchPolicy: "network-only",
    });

    const degrees = data?.allDegrees ? mapDegrees(data.allDegrees) : [];

    useEffect(() => {
        if (value?.length > 0 && degreeLevel) {
            setKey(degreeLevel);
            onChange({target: {value: [], name}});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [degreeLevel]);

    return (
        <AccessibleReactSelect
            key={key}
            name={name}
            id={name}
            filterLabel={placeholder}
            options={degrees}
            aria-label={placeholder}
            placeholder={placeholder}
            isMulti={multiple}
            noOptionsMessage={() => t(INTL_EMPTY_DEGREE.key, INTL_EMPTY_DEGREE.defaultValue)}
            loadingMessage={() => t(INTL_LOADING.key, INTL_LOADING.defaultValue)}
            selected={value}
            onChange={(newValue) => onChange({target: {value: newValue, name}})}
            onBlur={(newValue) => onBlur({target: {value: newValue, name}})}
            isLoading={loading}
            required
        />
    );
};

DegreeAutocomplete.propTypes = {
    universitySlug: PropTypes.string.isRequired,
};

DegreeAutocomplete.defaultProps = {
    degreeLevel: "",
    multiple: false,
    placeholder: "Search...",
    onChange: noop,
    onBlur: noop,
};

export default compose(withTranslation(IntlNamespaces.SIGNUP))(DegreeAutocomplete);
